import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/modules/authentication/services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription, first } from 'rxjs';
import { UserSetupService } from 'src/app/modules/user-profile/services/user-setup.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss']
})
export class AuthCallbackComponent implements OnInit {

  error: boolean;
  redirectTo: any;
  private unsubscribe: Subscription[] = [];
  userProfile: any;
  isLoading$: Observable<boolean>;

  constructor(private authService: AuthenticationService, private router: Router, private route: ActivatedRoute, private userSetupService: UserSetupService) {}

  
  async ngOnInit() {
    if (this.route.snapshot.fragment.indexOf('error') >= 0) {
       this.error=true; 
       return;    
     }

    let authenticated = await this.authService.completeAuthentication();  
    this.userSetupService.getUserDetails().subscribe(res => {
       let userProfile = res
      if (userProfile?.pageSetup?.serverUrl)
        {
          //  if baseurl == userProfile?.pageSetup?.serverUrl then ignore
          // if baseurl !== userProfile?.pageSetup?.serverUrl then redirect to serverurl
          if (environment.baseurl==userProfile?.pageSetup?.serverUrl) {
            if (localStorage.getItem('pageUrl')) {
              this.router.navigate(JSON.parse(localStorage.getItem('pageUrl')));
            }else{
              this.router.navigate(['claims-tracker']);
            }  
          }else{
            if (localStorage.getItem('validate')=='false') {
            console.log('block 2');

              if (localStorage.getItem('pageUrl')) {
                this.router.navigate(JSON.parse(localStorage.getItem('pageUrl')));
              }else{
                this.router.navigate(['claims-tracker']);
                console.log('block 2','claims-tracker');

              } 
            }else{
              window.open(`${ userProfile?.pageSetup?.serverUrl }`, '_self');
            }
          }
        }else{
          if (localStorage.getItem('pageUrl')) {
            this.router.navigate(JSON.parse(localStorage.getItem('pageUrl')));
          }else{
            this.router.navigate(['claims-tracker']);
          }  
        }
    })
    // this.redirectTo = localStorage.getItem('redirectTo')
    // if (localStorage.getItem('pageUrl')) {
    //   this.router.navigate(JSON.parse(localStorage.getItem('pageUrl')));
    // }else{
    //   this.router.navigate(['claims-tracker']);
    // }  
  }

  // private getUserInfo() {
  //   const subscription = this.userSetupService.getUserDetails()
  //     .pipe(first())
  //     .subscribe((res: any) => {
  //       this.userProfile = res;
  //       // SuperAdmin, BpkAdmin, BpkUser
  //     });
  //   this.unsubscribe.push(subscription);
  // }

}
